export const WAKTU_TEMPUH_URL = 'dashboard/waktu_tempuh'
export const WAKTU_TEMPUH_ERROR = 'WAKTU_TEMPUH_ERROR'
export const WAKTU_TEMPUH_LOADING = 'WAKTU_TEMPUH_LOADING'
export const WAKTU_TEMPUH_SUCCESS = 'WAKTU_TEMPUH_SUCCESS'